import { api, type ApiResponse } from '../utils';

const getDashboardStats = async (): Promise<ApiResponse> => {
  const { data: response } = await api.get('/dashboard/quick-stats');
  return response;
};

const getDashboardAiMatchAnalytics = async (
  eventId?: string | null
): Promise<ApiResponse> => {
  // Multi-event: an event_id scopes the metrics to that event's matches so the
  // stats header agrees with the event-filtered list rendered under it.
  const endpoint = eventId
    ? `/dashboard/ai-match-analytics?event_id=${encodeURIComponent(eventId)}`
    : '/dashboard/ai-match-analytics';
  const { data: response } = await api.get(endpoint);
  return response;
};

const getDashboardRecentActivity = async (): Promise<ApiResponse> => {
  const { data: response } = await api.get('/dashboard/recent-agent-activity');
  return response;
};

const getDashboardInsights = async (): Promise<ApiResponse> => {
  const { data: response } = await api.get('/dashboard/insights');
  return response;
};

export {
  getDashboardStats,
  getDashboardAiMatchAnalytics,
  getDashboardRecentActivity,
  getDashboardInsights,
};
